/* eslint-env browser */
// @flow
import React, { Children, type Node, useContext } from 'react';
import ReactDom from 'react-dom';
import ResponsiveContext from 'Components/utils/responsive/responsiveContext';

import { AFTER_APP } from './Portal.constants';

export type PortalProps = {
  children: Node,
  name?: string,
};

export default function Portal(props: PortalProps) {
  const { isAppMounted } = useContext(ResponsiveContext);

  if (!isAppMounted) {
    return null;
  }

  const { children, name = AFTER_APP } = props;

  const htmlElement = document && document.getElementById(name);

  if (!htmlElement) {
    return null;
  }

  return Children.count(children) ? ReactDom.createPortal(children, htmlElement) : null;
}
